import { Settings } from "luxon";
import { matchSystemLocale } from "../OS/getActiveLocale";

const weekdays = {
  sv: [
    { narrow: "M", short: "mån", long: "Måndag" },
    { narrow: "T", short: "tis", long: "Tisdag" },
    { narrow: "O", short: "ons", long: "Onsdag" },
    { narrow: "T", short: "tors", long: "Torsdag" },
    { narrow: "F", short: "fre", long: "Fredag" },
    { narrow: "L", short: "lör", long: "Lördag" },
    { narrow: "S", short: "sön", long: "Söndag" },
  ],
  en: [
    { narrow: "M", short: "Mon", long: "Monday" },
    { narrow: "T", short: "Tue", long: "Tuesday" },
    { narrow: "W", short: "Wed", long: "Wednesday" },
    { narrow: "T", short: "Thu", long: "Thursday" },
    { narrow: "F", short: "Fri", long: "Friday" },
    { narrow: "S", short: "Sat", long: "Saturday" },
    { narrow: "S", short: "Sun", long: "Sunday" },
  ],
  nb: [
    { narrow: "M", short: "man", long: "Mandag" },
    { narrow: "T", short: "tir", long: "Tirsdag" },
    { narrow: "O", short: "ons", long: "Onsdag" },
    { narrow: "T", short: "tor", long: "Torsdag" },
    { narrow: "F", short: "fre", long: "Fredag" },
    { narrow: "L", short: "lør", long: "Lørdag" },
    { narrow: "S", short: "søn", long: "Søndag" },
  ],
};

export function useWeekdays(
  type: "narrow" | "short" | "long",
  locale?: string
) {
  const l = locale ?? Settings.defaultLocale;

  const matchedLocale = matchSystemLocale(l);

  return weekdays[matchedLocale].map((v) => v[type]) ?? [];
}
